var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "answer-form"
  }, [_vm.error ? _c('Note', {
    staticClass: "mb-10",
    attrs: {
      "theme": "reddish"
    }
  }, [_vm._v("\n    Что-то пошло не так\n  ")]) : _c('div', {
    staticClass: "answer-form__content"
  }, [_c('ValidationObserver', {
    ref: "observer"
  }, [_c('ValidationProvider', {
    attrs: {
      "rules": "required|email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.fields.email,
            expression: "fields.email"
          }],
          staticClass: "answer-form__email",
          class: [{
            'answer-form__email_error': errors[0]
          }],
          attrs: {
            "type": "text",
            "placeholder": "Для получения уведомлений укажите ваш email",
            "data-e2e": "answer-form-email"
          },
          domProps: {
            "value": _vm.fields.email
          },
          on: {
            "input": function ($event) {
              if ($event.target.composing) { return; }

              _vm.$set(_vm.fields, "email", $event.target.value);
            }
          }
        })];
      }
    }])
  }), _vm._v(" "), _c('ValidationProvider', {
    attrs: {
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('TextareaButton', {
          attrs: {
            "height": _vm.height,
            "padding": _vm.padding,
            "border": _vm.border,
            "placeholder": _vm.userName ? ((_vm.userName) + ", ") : 'Ваш вопрос',
            "error": !!errors[0],
            "data-e2e": "answer-form-comment"
          },
          on: {
            "update:model-value": function ($event) {
              _vm.fields.text = $event;
            }
          },
          model: {
            value: _vm.fields.text,
            callback: function ($$v) {
              _vm.$set(_vm.fields, "text", $$v);
            },
            expression: "fields.text"
          }
        })];
      }
    }])
  }), _vm._v(" "), _vm.status === 'loading' ? _c('div', {
    staticClass: "answer-form__button"
  }, [_vm._v("\n        Отправляем...\n      ")]) : _vm.submited ? _c('div', {
    staticClass: "green-text"
  }, [_vm._v("\n        Комментарий отправлен!\n      ")]) : _c('div', {
    staticClass: "answer-form__button",
    attrs: {
      "data-e2e": "answer-form-submit"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n        Оставить комментарий\n      ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }